import React, { Reducer, useCallback, useMemo, useReducer, useState } from "react";
import { useTranslation } from "react-i18next"
import { glyphs } from "../../../Styles";
import { StartSectionModal, CalibrateLfSectionModal, EmptyLfSectionModal, SystemControls } from "../..";
import { currentLfViewTypes, ILfContext, LfContext, LfDispatcherT, LfReducer, systemControleTypes } from "../_LocationFeeder/lfPenContext";
import { AttentionTypes } from "../../../Definitions";
import { Graph_QL, useSystem } from "../../../Services";
import { useAppSelector } from "../../../Store";

interface LfSystemControls_Props {
  systemId: number
  focus_view?: boolean
}
/**
 * SystemControls
 * @returns A widget with btns to controle the system.
 */
export default function LfSystemControls({ systemId, focus_view }: LfSystemControls_Props) {
  const {t} = useTranslation();
  const [isOn, setIsOn] = useState<boolean>(true)
  const [openModal, setOpenModal] = useState<"START" | "CALIBRATE" | "EMPTY" | null >(null)
  
  const farm = useAppSelector(({ activeData }) => activeData.farm) ?? "";
  const domain = useMemo(() => (Graph_QL.ObjToString({domain: farm})),[farm]);
  const connection = useMemo(() => (Graph_QL.create({domain: farm})),[farm]);

  const { data: systemsState, emergencyStopSystem } = useSystem(connection); 

  const [_state, dispatch] = useReducer<Reducer<ILfContext, LfDispatcherT>>(LfReducer, {
    farm: farm,
    domain: domain,
    connection: connection,
    systemId: systemId,
    selectedPens: [],
    nextFeeding_LocationsToFeed: [],
    section: undefined,
    locationResults: undefined,
    currentPenViewType: currentLfViewTypes.systemControle,
    systemControlePen: {
      systemControleType: undefined
    },
    error: { Elementid: 0, errorText: "" }
  } as ILfContext);

  const handleCloseModal = () => {
    if (!openModal) return;
    setOpenModal(null);
    dispatch({
      selectedPens: [],
      nextFeeding_LocationsToFeed: [],
      selectedSection: undefined,
      locationResults: undefined,
      systemControlePen: {
        systemControleType: undefined
      },
      error: { Elementid: 0, errorText: "" }
    });
  }

  const { attentionType } = useMemo(() => {
    let _attentionType = systemsState[domain]?.data.find((system) => system.system_id === systemId)?.system_attention_type ?? AttentionTypes.good;

    // if (lanLogs && lanLogs.length > 0) {
    //   const hasLevel0 = lanLogs.some(log => log.level === 0);
    //   const hasLevel1 = lanLogs.some(log => log.level === 1);
  
    //   if (hasLevel0) {
    //     _attentionType = AttentionTypes.alert;
    //   } else if (hasLevel1) {
    //     _attentionType = AttentionTypes.warning;
    //   }
    // }

    return {attentionType: _attentionType}
  }, [domain, systemId, systemsState])

  const handleButtonClick = useCallback((i: number) => {
    if (i === 0) { setOpenModal("START"); dispatch({ systemControlePen: { systemControleType: systemControleTypes.startSection }})}
    if (i === 1) { setOpenModal("CALIBRATE"); dispatch({ systemControlePen: { systemControleType: systemControleTypes.calibrateSection }})}
    if (i === 2) { setOpenModal("EMPTY"); dispatch({ systemControlePen: { systemControleType: systemControleTypes.emptySection }})}
    if (i === 3) {
    if (isOn) {
      if (window.confirm(t("systemControls.general.confirmStop", {defaultValue: "Would you like to proceed the emergency stop of the system?"}))) { setIsOn(false); emergencyStopSystem(systemId) }
    } else {
      setIsOn(true);
    }
  }
  }, [isOn, t, emergencyStopSystem, systemId]);
  
  return( <LfContext.Provider value={{ state: _state, dispatch}}>
    <SystemControls
      handleButtonClick={handleButtonClick}
      attentionType={attentionType}
      systemRunning={isOn}
      focus_view={focus_view}
      buttonContents={[
        t("systemControls.general.startSection", {defaultValue: "Start Section"}),
        t("systemControls.general.calibrateSection", {defaultValue: "Calibrate Section"}),
        t("systemControls.general.emptySection", { defaultValue: "Empty Section" })
      ]}
      buttonEnhancers={[
        glyphs.Start({ size: focus_view ? "40px" : "35px" }),
        glyphs.Calibrate({ size: focus_view ? "40px" : "35px" }),
        glyphs.Empty({ size: focus_view ? "40px" : "35px" }),
      ]}
    />

    <StartSectionModal isModalOpen={openModal === "START"} onClose={handleCloseModal} focus_view={focus_view}/>
    <CalibrateLfSectionModal isModalOpen={openModal === "CALIBRATE"} onClose={handleCloseModal} focus_view={focus_view}/>
    <EmptyLfSectionModal isModalOpen={openModal === "EMPTY"} onClose={handleCloseModal} focus_view={focus_view}/>
  </LfContext.Provider> )
}

